<template>
    <v-container fluid>
        <v-progress-linear
            v-if="loading"
            class="mb-8"
            color="primary"
            indeterminate
        ></v-progress-linear>
        <v-row v-if="!loading">
            <v-col cols="12">
                <v-card class="elevation-0">
                    <v-card-title class="d-none d-lg-block warning white--text">
                        Materiais
                    </v-card-title>
                    <v-card-title class="d-block d-lg-none warning white--text text-caption text-center">
                        Materiais
                    </v-card-title>
                    <v-card-text :key="reloader">
                        <v-simple-table class="d-none d-lg-block" fixed-header>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th v-if="aggregator" width="5%"></th>
                                        <th class="text-left" :width="aggregator ? '20%' : '15%'">
                                            Frente Obra
                                        </th>
                                        <th class="text-left" :width="aggregator ? '20%' : '15%'">
                                            Classe
                                        </th>
                                        <th class="text-left" width="15%">
                                            Artigo
                                        </th>
                                        <th class="text-left" width="7%">
                                            Un
                                        </th>
                                        <th class="text-left" width="7%">
                                            QTD
                                        </th>
                                        <th class="text-left" width="5%">
                                            Nota
                                        </th>
                                        <th class="text-left" width="10%">
                                            Opções
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in computeMateriais" :key="item.id"
                                    >
                                        <td v-if="aggregator">
                                            <v-icon v-if="lineTotalApproved(item)" color="success">mdi-check-decagram</v-icon>
                                            <span v-else>{{lineApprovalState(item)}}</span>
                                        </td>
                                        <td>
                                            <div v-if="showFrente(item)">
                                                <validation-provider v-slot="{ errors }" vid="Frentes" name="Frentes" rules="|">
                                                    <v-autocomplete                                                                                
                                                        v-model="item.frente_id"
                                                        :items="frentes_obra"
                                                        outlined dense
                                                        class="mt-4"
                                                        :item-text="ob => getText(ob)"
                                                        item-value="ID"
                                                        :error-messages="errors"
                                                        label="Frentes de Obra *"
                                                        @change="changeFrenteObraV2(item)"
                                                    />
                                                </validation-provider>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="showClasse(item)">
                                                <validation-provider v-slot="{ errors }" vid="Classes" name="Classes" rules="required">
                                                    <v-autocomplete
                                                        v-model="item.classe_id"
                                                        :items="item.available_classes"
                                                        class="mt-4"
                                                        outlined dense
                                                        :item-text="ob => ob.Descricao"
                                                        item-value="ID"
                                                        :error-messages="errors"
                                                        label="Classe *"
                                                    />
                                                </validation-provider>
                                            </div>
                                        </td>
                                        <td>
                                            <validation-provider v-if="toEditRow(item)" v-slot="{ errors }" vid="equipamento" name="equipamento" rules="required">
                                                <v-autocomplete
                                                    class="mt-4"
                                                    outlined dense
                                                    :items="materiais"
                                                    :item-text="item => item.artigo + ' - ' + item.descricao"
                                                    item-value="id"
                                                    label="Material"
                                                    :error-messages="errors"
                                                    v-model="item.material"
                                                    @change="changeItem(item)"
                                                />
                                            </validation-provider>
                                                <v-text-field
                                                    v-else
                                                    class="mt-4"
                                                    outlined dense
                                                    :value="item.material"
                                                    label="Material"
                                                    :disabled="true"
                                                />
                                        </td>
                                        <td>
                                            <v-autocomplete  v-if="toEditRow(item)"
                                                class="mt-4"
                                                outlined dense
                                                :items="materiais"
                                                :item-text="item => item.unidade_base"
                                                item-value="id"
                                                label="Unidade"
                                                v-model="item.material"
                                                disabled
                                            />
                                            <v-text-field
                                                v-else
                                                dense outlined
                                                class="mt-4"
                                                label="Unidade"
                                                :disabled="true"
                                                :value="item.unidade"
                                            />
                                        </td>
                                        <td>
                                            <v-text-field
                                                class="mt-n3"
                                                outlined
                                                dense
                                                placeholder="Insira qtd."
                                                type="text"
                                                inputmode="decimal"
                                                :value="item.qty"
                                                hide-details="auto"
                                                :rules="[v => v === '' || /^[0-9]*\.?[0-9]*$/.test(String(v)) || 'Só números e ponto']"
                                                @input="val => onQtyInput(item, val)"
                                                @keypress.native="onKeypressDecimal"
                                                @paste.native.prevent="e => onPasteDecimal(item, e)"
                                            />
                                        </td>
                                        <td>
                                            <v-btn :class="item.local == null || item.local == '' ? 'primary elevation-0' : 'primary elevation-10'" fab x-small @click="$emit('nota', item, 'material')">
                                                <v-icon v-if="item.local == null || item.local == ''">mdi-note-edit</v-icon>
                                                <v-badge
                                                    v-else
                                                    color="orange"
                                                    dot
                                                    overlap
                                                >
                                                    <v-icon>mdi-note-plus</v-icon>
                                                </v-badge>
                                            </v-btn>
                                        </td>
                                        <td>
                                            <v-btn
                                                v-if="!aggregator"
                                                dark
                                                small
                                                color="error"
                                                @click="deleteMaterial(item.id)"
                                                >
                                                <v-icon small>mdi-delete</v-icon>
                                            </v-btn>   
                                            <v-btn
                                                v-if="aggregator"
                                                fab
                                                dark
                                                x-small
                                                outlined
                                                color="warning"
                                                @click="edit(item)"
                                            >
                                                <v-icon dark>
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>                         
                                        </td>
                                    
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <v-data-iterator
                            :items="computeMateriais"
                            item-key="id"
                            :items-per-page="-1"
                            hide-default-footer
                            class="d-block d-lg-none"
                        >
                        <template v-slot:default="{ items }">
                            <v-row>
                                <v-col
                                    v-for="item in computeMateriais"
                                    :key="item.id"
                                    cols="12"
                                >
                                    <v-card elevation="0" class="mt-2 rounded-lg" outlined>
                                        <v-list
                                            dense
                                        >
                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <div v-if="showFrente(item)">
                                                        <validation-provider v-slot="{ errors }" vid="Frentes" name="Frentes" rules="|">
                                                            <v-autocomplete                                                                                
                                                                v-model="item.frente_id"
                                                                :items="frentes_obra"
                                                                outlined dense
                                                                class="mt-4"
                                                                :item-text="ob => getText(ob)"
                                                                item-value="ID"
                                                                :error-messages="errors"
                                                                label="Frentes de Obra *"
                                                                @change="changeFrenteObraV2(item)"
                                                            />
                                                        </validation-provider>
                                                    </div>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <div v-if="showClasse(item)">
                                                        <validation-provider v-slot="{ errors }" vid="Classes" name="Classes" rules="required">
                                                            <v-autocomplete
                                                                v-model="item.classe_id"
                                                                :items="item.available_classes"
                                                                class="mt-4"
                                                                outlined dense
                                                                :item-text="ob => ob.Descricao"
                                                                item-value="ID"
                                                                :error-messages="errors"
                                                                label="Classe *"
                                                            />
                                                        </validation-provider>
                                                    </div>
                                                </v-list-item-content>
                                            </v-list-item>


                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <validation-provider v-slot="{ errors }" vid="equipamento" name="equipamento" rules="required">
                                                        <v-autocomplete
                                                            class="mt-4"
                                                            outlined dense
                                                            :items="materiais"
                                                            :item-text="item => item.artigo + ' - ' + item.descricao"
                                                            item-value="id"
                                                            label="Material"
                                                            :error-messages="errors"
                                                            v-model="item.material"
                                                            @change="changeItem(item)"
                                                        />
                                                    </validation-provider>     
                                                </v-list-item-content>                                                                   
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <v-autocomplete
                                                        class="mt-4"
                                                        outlined dense
                                                        :items="materiais"
                                                        :item-text="item => item.unidade_base"
                                                        item-value="id"
                                                        label="Material"
                                                        v-model="item.material"
                                                        disabled
                                                    />
                                                </v-list-item-content>                                                                            
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <v-text-field
                                                        label="Quantidade"
                                                        outlined
                                                        dense
                                                        placeholder="Insira qtd."
                                                        type="text"
                                                        inputmode="decimal"
                                                        :value="item.qty"
                                                        hide-details="auto"
                                                        :rules="[v => v === '' || /^[0-9]*\.?[0-9]*$/.test(String(v)) || 'Só números e ponto']"
                                                        @input="val => onQtyInput(item, val)"
                                                        @keypress.native="onKeypressDecimal"
                                                        @paste.native.prevent="e => onPasteDecimal(item, e)"
                                                    />
                                                </v-list-item-content>                                                                            
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <v-btn :class="item.local == null || item.local == '' ? 'primary elevation-0' : 'primary elevation-10'" fab small @click="$emit('nota', item, 'material')">
                                                        <v-icon v-if="item.local == null || item.local == ''">mdi-note-edit</v-icon>
                                                        <v-badge
                                                            v-else
                                                            color="orange"
                                                            dot
                                                            overlap
                                                        >
                                                            <v-icon>mdi-note-plus</v-icon>
                                                        </v-badge>
                                                    </v-btn>
                                                </v-list-item-content>                                                                            
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <v-btn
                                                        v-if="!aggregator"
                                                        dark
                                                        small
                                                        color="error"
                                                        @click="deleteMaterial(item.id)"
                                                        >
                                                        <v-icon small>mdi-delete</v-icon>
                                                    </v-btn>   
                                                    <v-btn
                                                        v-if="aggregator"
                                                        fab
                                                        dark
                                                        x-small
                                                        outlined
                                                        color="warning"
                                                        @click="edit(item)"
                                                    >
                                                        <v-icon dark>
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>           
                                                </v-list-item-content>                                                                            
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>
                        </v-data-iterator>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" align="center" v-if="newLines">
                <v-btn fab @click="addMaterial" class="primary">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Materiais from "@/api/Materiais.js"
import Classe from "@/api/Classe.js"
import dayjs from 'dayjs'

export default{
    name:"Materials",
    props:{
        newLines: {
            typeof: Boolean,
            default: true
        },
        aggregator: {
            typeof: Boolean,
            default: false
        },
        obra_selecionada:{
            typeof: Object,
            default: null
        },
        fields: Object,
        loadedClasses: Array,
        obraCodigo: { type: String, default: null },
        frentes_obra: Array,
        hideFrentes: Boolean,
    },
    watch:{
        loadedClasses(val){
            if(this.hideFrentes && Array.isArray(val)) this.classes = val
        },
        'fields.materiais':{
            immediate: true,
            handler(val){
                console.log(val)
            }
        }
    },
    data(){
        return{
            classes: [],
            materiais: [],
            loading: true,
            reloader: 0
        }
    },
    mounted(){
        this.classes = Array.isArray(this.loadedClasses) ? this.loadedClasses : []
        this.fillBaseData()
    },
    methods:{
            // mantém apenas dígitos e UM ponto
        sanitizeDecimal(v) {
            v = String(v || '');
            v = v.replace(/,/g, '');      // remove vírgulas
            v = v.replace(/[^\d.]/g, ''); // só dígitos e ponto
            const i = v.indexOf('.');
            if (i !== -1) v = v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, '');
            return v;
        },

        onQtyInput(item, val) {
            this.$set(item, 'qty', this.sanitizeDecimal(val));
        },

        onKeypressDecimal(e) {
            if (e.ctrlKey || e.metaKey) return; // permitir copiar/colar/select-all
            const k = e.key;
            if (k >= '0' && k <= '9') return;
            if (k === '.') {
            if (e.target.value.indexOf('.') !== -1) e.preventDefault(); // só um ponto
            return;
            }
            // bloqueia tudo o resto (inclui vírgula)
            e.preventDefault();
        },

        onPasteDecimal(item, e) {
            const text = (e.clipboardData || window.clipboardData).getData('text');
            const sanitized = this.sanitizeDecimal(text);
            const el = e.target;
            const start = el.selectionStart, end = el.selectionEnd;
            const newVal = el.value.slice(0, start) + sanitized + el.value.slice(end);
            this.$set(item, 'qty', this.sanitizeDecimal(newVal));
        },
        getText(ob) {
            if (ob.Descricao && ob.SubEmp && ob.Descricao.includes(ob.SubEmp)) {
                return ob.Descricao;
            }

            return `${ob.SubEmp} - ${ob.Descricao}`;
        },
        lineApprovalState(item){            
            if(this.obra_selecionada == null)
                return null;
            

            let obra_nivel = this.obra_selecionada.approval_level == null ? 2 : this.obra_selecionada.approval_level
            return (item.approval == null ? 0 : item.approval) + '/' + obra_nivel
        },
        lineTotalApproved(item){  
            if(this.obra_selecionada == null)
                return false;

            if(item.approval == null)
                return false
                
            if(parseInt(this.obra_selecionada.obra.approval_level) == parseInt(item.approval))
                return true

            return false
        },
        edit(item){
            //this.$router.push("/diarios/encarregado/editar/" + item.webAppLinkHash + "/" + item.id_user);
            window.open(process.env.VUE_APP_API_URL + '/diarios/encarregado/editar/' + item.webAppLinkHash + "/" + item.user_id, '_blank')
        },
        toEditRow(item){
            if(item.id.includes('new'))
                return true

            return false
        },
        showClasse(item){
            if(item.classeNeeded)
                return true

            return false
        },
        showFrente(item){
            if(this.fields.obra_id != null && this.hideFrentes == false)
                return true

            return false
        },
        async changeFrenteObraV2(item){
            this.$set(item, 'classe_id', null)
            this.$set(item, 'available_classes', [])
            this.$set(item, 'classeNeeded', false)
            const frente = this.frentes_obra.find(f => f.ID == item.frente_id)
            if(!frente) return
            try {
                let classes = Array.isArray(frente.classes) ? frente.classes : []
                if(!classes.length){
                    const resp = await Classe.getClasses({SubEmp: frente.SubEmp, obra: this.obraCodigo || null})
                    classes = Array.isArray(resp.data) ? resp.data : []
                    this.$set(frente, 'classes', classes)
                }
                this.$set(item, 'available_classes', classes)
                this.$set(item, 'classeNeeded', classes.length > 0)
            } catch(error){
                console.error('Erro ao carregar classes do material:', error)
            }
        },
        changeItem(item){
            this.materiais.forEach(element => {
                if(element.id == item.material){
                    item.unidade = element.unidade_base
                }
            });
        },
        deleteMaterial(id){
            let pos = -1    
            let i = 0
            this.fields.materiais.forEach(element => {
                if(element.id == id)
                    pos = i

                i++
            });

            this.fields.deleteMaterial.push(id)
            this.fields.materiais.splice(pos, 1)
            this.reloader++
        },        
        classesPorObra(){
            // Também temos de verificar se esta obra tem classes
            Classe.getClassesByObraPai(this.fields.obra_id).then((resp) =>  {
                this.classes = resp.data
               
            })
        },
        addMaterial(){
            let available_classes = []
            let classeNeeded = false;
            if(this.hideFrentes){
                available_classes = this.classes;
                classeNeeded = true;
            }

            this.fields.materiais.push({
                id: dayjs().unix() + '-new',
                material: null,
                frente_id: null,
                classe_id: null,
                classeNeeded: classeNeeded,
                available_classes: available_classes,
                un: "-",
                qty: 0,
                local: null,
                familia: null,
                subfamilia: null,
                Unidade: '-',
                options: ""
            });
            
            this.reloader++
        },
        async fillBaseData(){
            let materialsData ={
                id_frente_obra: "null",
                id_obra_classe: "null",
                obra_id: this.fields.obra_id
            }

            await Materiais.getList(materialsData).then((resp)    =>  {
                this.materiais = resp.data
            })

            if(this.hideFrentes){
                this.classesPorObra()
            }

            /*materialsData.obra_id = "null"
            Materiais.getList(materialsData).then((resp)    =>  {
                this.allDBMateriaisl = resp.data
            })*/

            this.loading = false

        },
        getUnity(i){
            if(i==null)
                return "-"

            if(i.product == null)
                return '-'
                
            return i.product.unidade || "-"
        },
    },
    computed:{
        computeMateriais(){
            let returner = []            

            this.fields.materiais.forEach(element => {

                if(element.classe_id != null){
                    if(this.hideFrentes == false){
                        this.frentes_obra.forEach(f => {
                            if(element.frente_id == f.ID){
                                if(Array.isArray(f.classes) && f.classes.length > 0){
                                    element.available_classes = f.classes
                                }
                            }
                        });
                    }else{
                        element.available_classes = this.classes
                    }
                    element.classeNeeded = true
                }
                
                returner.push(element)
            });

            return returner
        }     
    }
}
</script>